import React from 'react';
import ResourceSubTile from "../dashboard/ResourceSubTile";

const CareCompanionTile = ({
    dashboardData,
    disabled,
    isShowAllUsers
}) => {

    const careCount = isShowAllUsers ? dashboardData?.data?.unreadCareCompanionCount : dashboardData?.data?.currentUser?.careCompanion?.unreadCount;

    return (
        <ResourceSubTile
            className="care-companion-tile"
            heading="Care Companion"
            description={careCount > 0
                ? <>Don’t forget about your daily check-ins!</>
                : <>See what’s next on your care journey.</>}
            disabled={disabled}
            count={careCount}
            url={"/familyselection/carecompanion"}
        />
    );
}

export default CareCompanionTile;
